import apiService from './Base/BaseRepository';

const url = '/rules';

export default {
  async fetchProperties(context) {
    return await apiService.get(`${url}/properties/${context}`);
  },
}
